/* global google, GMaps, MarkerClusterer */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import * as constants from '../util/constants';
import helpers from '../util/helpers';

const MapSkeleton = () => {
  return (
    <div className="map-wrapper skeleton-shine" />
  );
};

class AppGlobalVenuesMap extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      resultLocations: [],
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.location = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_LOCATION);
    this.occasion = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_OCCASION);
    this.guests = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_GUESTS);

    // Bind "this"
    this.loadSearchResults = this.loadSearchResults.bind(this);
    this.loadMap = this.loadMap.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  componentDidMount() {
    // Load results on first page load
    this.loadSearchResults();

    // Reload results on input changes
    document.addEventListener(constants.EVENT_SUBMIT_CLICKED_SEARCH, () => {
      const location = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_LOCATION);
      const occasion = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_OCCASION);
      const guests = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_GUESTS);

      if (this.location !== location || this.occasion !== occasion || this.guests !== guests) {
        this.location = location;
        this.occasion = occasion;
        this.guests = guests;
        this.loadSearchResults();
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.loading && !this.state.loading) {
      this.loadMap();
    }
  }

  loadSearchResults() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState(this.initialState);

    // Params
    const data = {
      'action': constants.ACTION_GET_GLOBAL_VENUE_LOCATIONS,
      'location': this.location,
      'occasion': this.occasion,
      'guests': this.guests,
    };

    // Send request
    axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const hotelsCount = response.data['hotels_count'];
          const hotelLocations = [...response.data['hotel_locations']];

          if (0 === hotelsCount) {
            this.setState({
              loading: false,
            });
          } else {
            this.setState({
              loading: false,
              resultLocations: hotelLocations,
            });
          }
        } else {
          this.setState({
            loading: false,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMap() {
    if ($('#global-venues-map').length) {
      const { resultLocations } = this.state;
      if (resultLocations.length > 0) {
        // Setup first item on map
        const map = new GMaps({
          div: '#global-venues-map',
          scrollwheel: false,
          center: new google.maps.LatLng(resultLocations[0]['location']['lat'], resultLocations[0]['location']['lng']),
          zoom: 15,
          markerClusterer: function(map) {
            return new MarkerClusterer(map, null, {
              styles: [
                {
                  textColor: 'white',
                  textSize: 20,
                  url: window.Rydges['assetsPath'] + 'images/map-markers/blank.svg',
                  height: 62,
                  width: 62,
                },
              ],
            });
          },
        });

        const mapMarkerInfoWindowTemplate = $('#hotels-map-marker-info-window').html();
        const bounds = [];

        for (let i = 0; i < resultLocations.length; i++) {
          if (Object.keys(resultLocations[i]['location']).length > 0) {
            const title = resultLocations[i]['title'];
            const lat = resultLocations[i]['location']['lat'];
            const lng = resultLocations[i]['location']['lng'];
            const link = resultLocations[i]['link'];

            bounds.push(new google.maps.LatLng(lat, lng));

            map.addMarker({
              lat: lat,
              lng: lng,
              title: title,
              icon: {
                scaledSize: new google.maps.Size(44, 44),
                url: window.Rydges['assetsPath'] + 'images/map-markers/default.svg',
              },
              infoWindow: {
                content: helpers.transformMapMarkerInfoWindow({
                  title,
                  image: resultLocations[i]['image'],
                  address: resultLocations[i]['address'],
                  link,
                }, mapMarkerInfoWindowTemplate),
              },
            });
          }
        }

        if (resultLocations.length > 1) {
          map.fitLatLngBounds(bounds);
        }
      }
    }
  }

  render() {
    const {
      loading,
    } = this.state;

    return (
      <React.Fragment>
        {
          !loading
            ? (
              <div id="global-venues-map" className="map-wrapper" />
            ) : (
              <MapSkeleton />
            )
        }
      </React.Fragment>
    );
  }
}

export default {
  init() {
    // JavaScript to be fired on init
  },
  finalize() {
    // JavaScript to be fired on loaded

    // Hero Search Location Form Sticky top
    const $window = $(window);
    const venuesWrapperOffset = $('#global-venues-wrapper').offset();
    const $HeroSearchLocationForm = $('.search-location-form');
    const $HeroSearchLocationFormWrapper = $HeroSearchLocationForm.closest('.form-wrapper');

    if (venuesWrapperOffset) {
      helpers.onWindowEvents(() => {
        const yPosition = $window.scrollTop();
        if (yPosition >= venuesWrapperOffset.top - 100) {
          $HeroSearchLocationFormWrapper.addClass('sticky-top');
        } else {
          $HeroSearchLocationFormWrapper.removeClass('sticky-top');
        }
      }, 0, 0, 1, 1);
    }

    // Venues
    const venuesWrapper = $('#global-venues-wrapper');
    if (venuesWrapper.length) {
      // Cancel token source
      let cancelTokenSource = null;

      const handleVenuesResults = function(offset = 0) {
        // Cancel previous request if it exists
        if (cancelTokenSource) {
          cancelTokenSource.cancel('New request initiated, cancel previous.');
        }
        cancelTokenSource = axios.CancelToken.source();

        const countLabel = $('#global-venues-count-label');
        const skeleton = $('#global-venues-skeleton');
        const loadMoreButtonWrapper = $('#global-venues-load-more-button-wrapper');
        let page = parseInt(venuesWrapper.data('page'), 10);
        const perPage = parseInt(venuesWrapper.data('per-page'), 10);
        const params = helpers.getParameters();

        if (offset === 0) {
          countLabel.text('');
          venuesWrapper.html('');
        }
        skeleton.show();
        loadMoreButtonWrapper.hide();

        // Params
        const data = {
          'action': constants.ACTION_GET_GLOBAL_VENUES,
          'location': params['location'] || '',
          'occasion': params['occasion'] || '',
          'guests': params['guests'] || '',
          'offset': offset,
        };

        // Send request
        axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
          cancelToken: cancelTokenSource.token,
        }).then((axiosResponse) => {
          if (200 === axiosResponse.status) {
            const response = axiosResponse.data;

            skeleton.hide();

            if (response.success) {
              const count = response.data['count'];
              const html = response.data['html'];

              if (html.length) {
                if (offset === 0) {
                  countLabel.text(`${count} Venue${count === 1 ? '' : 's'}`);
                  venuesWrapper.html(html);
                  page = 1;
                  offset = perPage;
                } else {
                  venuesWrapper.append(html);

                  // Increment page and offset
                  page += 1;
                  offset += perPage;
                }

                // Update attributes
                venuesWrapper.data('page', page).attr('data-page', page);
                venuesWrapper.data('offset', offset).attr('data-offset', offset);

                // Update URL
                params['page_number'] = page;
                helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

                // Equal height for elements
                $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);

                if (offset >= count) {
                  loadMoreButtonWrapper.hide();
                } else {
                  loadMoreButtonWrapper.show();
                }
              } else {
                loadMoreButtonWrapper.hide();
              }
            } else {
              loadMoreButtonWrapper.hide();
            }
          }
        }).catch((error) => {
          console.log(error);
        });
      };

      const searchEventsForm = $('.search-events');
      if (searchEventsForm.length) {
        const venueLocationsSearch = searchEventsForm.find('.where');
        const venueOccasionsSearch = searchEventsForm.find('.occasions-search');
        const venueGuestsSearch = searchEventsForm.find('.guests-search');
        const venueLocation = helpers.getParameterByName('location');
        const venueOccasion = helpers.getParameterByName('occasion');
        const venueGuests = helpers.getParameterByName('guests');
        const venueLocationCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_LOCATION);
        const venueOccasionCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_OCCASION);
        const venueGuestsCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_GUESTS);
        const params = helpers.getParameters();

        // Set url params to cookie
        if (venueLocation != null && venueLocation.length) {
          params['location'] = venueLocation;
          venueLocationsSearch.val(venueLocation);
          helpers.docCookies.setItem(venueLocationsSearch.data('cookie-location'), venueLocation, 1500, '/');
        }
        if (venueOccasion != null && venueOccasion.length) {
          params['occasion'] = venueOccasion;
          venueOccasionsSearch.val(venueOccasion);
          helpers.docCookies.setItem(venueOccasionsSearch.data('cookie-occasion'), venueOccasion, 1500, '/');
        }
        if (venueGuests != null && venueGuests.length) {
          params['guests'] = venueGuests;
          venueGuestsSearch.val(venueGuests);
          helpers.docCookies.setItem(venueGuestsSearch.data('cookie-guests'), venueGuests, 1500, '/');
        }

        // Set cookie to url params
        if ((venueLocation == null && venueLocationCookie) || (venueOccasion == null && venueOccasionCookie) || (venueGuests == null && venueGuestsCookie)) {
          if (venueLocationsSearch.length && venueLocation == null && venueLocationCookie) {
            params['location'] = venueLocationCookie;
            venueLocationsSearch.val(venueLocationCookie);
          }
          if (venueOccasionsSearch.length && venueOccasion == null && venueOccasionCookie) {
            params['occasion'] = venueOccasionCookie;
            venueOccasionsSearch.val(venueOccasionCookie);
          }
          if (venueGuestsSearch.length && venueGuests == null && venueGuestsCookie) {
            params['guests'] = venueGuestsCookie;
            venueGuestsSearch.val(venueGuestsCookie);
          }
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        const handleUrlParamsOnInput = function() {
          const params = helpers.getParameters();

          if (venueLocationsSearch.length && venueLocationsSearch.val() !== '') {
            params['location'] = venueLocationsSearch.val();
          } else {
            delete params['location'];
          }
          if (venueOccasionsSearch.length && venueOccasionsSearch.val() !== '') {
            params['occasion'] = venueOccasionsSearch.val();
          } else {
            delete params['occasion'];
          }
          if (venueGuestsSearch.length && venueGuestsSearch.val() !== '') {
            params['guests'] = venueGuestsSearch.val();
          } else {
            delete params['guests'];
          }

          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');
        };

        const submitButton = searchEventsForm.find('button[type="submit"]');

        searchEventsForm.find('.where, .occasion, .guest')
          .on('input', function() {
            const _this = $(this);

            if (_this.val().length === 0) {
              handleUrlParamsOnInput();

              submitButton.prop('disabled', false);
            } else {
              submitButton.prop('disabled', true);
            }
          })
          .on('input_changed.rsd-ac', function() {
            handleUrlParamsOnInput();

            submitButton.prop('disabled', false);
          });

        // Trigger search on submit button clicked
        submitButton.on('click', function(e) {
          e.preventDefault();

          handleVenuesResults();

          document.dispatchEvent(helpers.initNewEvent(constants.EVENT_SUBMIT_CLICKED_SEARCH));
        });
      }

      const globalVenuesLoadMoreButton = $('#global-venues-load-more-button');
      if (globalVenuesLoadMoreButton.length) {
        globalVenuesLoadMoreButton.on('click', function(e) {
          e.preventDefault();

          const offset = parseInt(venuesWrapper.data('offset'), 10) || 0;

          handleVenuesResults(offset);
        });
      }

      const globalVenuesViewTypes = $('#global-venues-view-types');
      if (globalVenuesViewTypes.length) {
        const items = globalVenuesViewTypes.find('.view-type-item');

        items.on('click', function(e) {
          e.preventDefault();

          const el = $(this);
          const view = el.data('view');

          items.removeClass('active');
          el.addClass('active');

          if (view === 'map') {
            $('#global-venues-list-container').hide();
            $('#global-venues-map-container').show();
          } else {
            $('#global-venues-map-container').hide();
            $('#global-venues-list-container').show();

            // Equal height for elements
            $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
          }
        });
      }

      // Trigger slick on results loaded
      const loadVenueSlider = () => {
        const slider = $('.single-hotel-wrapper .slider');
        if (slider.length) {
          slider.each(function() {
            const _this = $(this);

            if (!_this.hasClass('slick-initialized')) {
              _this.slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                mobileFirst: true,
                prevArrow: _this.closest('.preview-images').find('.prev'),
                nextArrow: _this.closest('.preview-images').find('.next'),
              });
            }
          });
        }
      };

      loadVenueSlider();

      $(document).on(constants.EVENT_BALANCE_ELEMENTS, loadVenueSlider);
    }

    // Map view
    const globalVenuesMapWrapper = $('#global-venues-map-wrapper');
    if (globalVenuesMapWrapper.length) {
      ReactDOM.render(<AppGlobalVenuesMap />, globalVenuesMapWrapper[0]);
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalHostEventSearch.js